export default __webpack_public_path__ + "maps-examples-view-annotation-basic-960-b04355e9a53acf9f83c01aca1cd353fd.webp";